import Vue from 'vue'
import router from './router'
import store from './store'
import {updateThemeColor,setStyle} from './utils/primaryColor'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import { PrevLoading } from './utils/loading';
import {Storage} from '@yld/yun-utils-common'
import { getSkinJson,getUserColor } from './api/user'
import { theme } from './utils/theme'

// 计数器
let count = 0

// 加载 loading
PrevLoading.start();

const userinfo = store.getters.userinfo || {}

if (!count && isEmpty(userinfo)) {
  // 获取主公司logo
  store.dispatch('user/getLogoUrl')
  // 获取用户信息
  store.dispatch('user/getInfo').then(async response => {
    // 皮肤处理
    if(window.location.hostname.includes('admin.geekyum')) {
      if(Storage.getStorage('adminThemeStyle')) {
        const model = Storage.getStorage('adminThemeStyle')
        setStyle(model)
        updateThemeColor(model.primary)
      } else {
        getSkinJson({appId:3,tenantInstanceId:response.tenantId}).then(response=>{
          const {data} = response
          if(data) {
            const model = JSON.parse(data)
            Storage.setStorage({key:'adminThemeStyle',value:model,expires:1*1000*60*60*12})
            setStyle(model)
            updateThemeColor(model.primary)
          } else {
            Storage.removeStorage('adminThemeStyle')
          }
        })
      }
    } else {
      if(Storage.getStorage('dayuThemeStyle')) {
        const model = Storage.getStorage('dayuThemeStyle')
        setStyle(model)
        updateThemeColor(model.primary)
      } else {
        var appId = 1;
        if(Number(Vue.prototype.$appId) === 90006){
          appId = 5;
        }
        // 需要走dayu个人用户主题色值的应用
        const customThemeApp = [90002, 90010, 90011, 90005, 90006, 10063, 90004, 90020]
        if (customThemeApp.includes(Number(Vue.prototype.$appId))) { 
          // 这里需要调接口获取dayu个人皮肤设置
          // 如果个人没有设置，则取租户原本的
          const res = await getUserColor()
          if (res.data && res.data.colorKey && res.data.colorKey.length >1) { 
            const model = theme[res.data.colorKey.split('-')[1]]
            Storage.setStorage({key:'themeColor',value:res.data.colorKey,expires:1*1000*60*60*12})
            Storage.setStorage({key:'dayuThemeStyle',value:model,expires:1*1000*60*60*12})
            setStyle(model)
            updateThemeColor(model.primary)
            return
          }
        }
        getSkinJson({appId:appId,tenantInstanceId:response.tenantId}).then(response=>{
          const {data} = response
          if(data) {
            const model = JSON.parse(data)
            Storage.setStorage({key:'dayuThemeStyle',value:model,expires:1*1000*60*60*12})
            setStyle(model)
            updateThemeColor(model.primary)
          } else {
            Storage.removeStorage('dayuThemeStyle')
          }
        })
      }
    }
  })
}

router.beforeEach(async(to, from, next) => {
  NProgress.configure({ showSpinner: false }) 
  NProgress.start()
  if (!!get(to, 'meta.title')) {
    document.title = to.meta.title
  }

  if (!count && isEmpty(userinfo)) {
    // 获取菜单
    var accessRoutes = []
    if(window.location.hostname.includes('admin.geekyum')){
      accessRoutes = await store.dispatch('permission/getUserAdminMenuList')
      // accessRoutes = await store.dispatch('permission/getUserMenuList')
    } else {
      // 大羽
      accessRoutes = await store.dispatch('permission/getUserMenuList')
    }
    // 动态添加可访问路由表
    await router.addRoutes(accessRoutes)
    await count++ 
    next({ ...to, replace: true })
  } else {
    next()
  }
  NProgress.done()
})

router.afterEach(() => {
  NProgress.done();
  PrevLoading.done();
})
